import React from 'react'
import Header from '../../../components/Header'
import TopNav from '../../../components/TopNav'
import Footer from '../../../components/Footer'
import { Container, Content } from './styles'

export interface PrivateProps {
  children: any
  title?: string
  fullPage?: boolean
}

const Private: React.FunctionComponent<PrivateProps> = ({ children, title, fullPage }) => {
  return (
    <Container fullPage={fullPage}>
      <Header title={title} />
      <TopNav />
      <Content>{children}</Content>
      <Footer />
    </Container>
  )
}

export default Private
